import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handlePost } from '../../../utils/AxiosUtil';

class ActivateObject extends Component {

    handleSubmit = async (event) => {
        // console.log(this.props.row);
        event.persist()
        event.preventDefault();
        const requestObject = {
            "privateId": this.props.row.privateId
        };
        handlePost(this.props.path, requestObject, this);
    };

    handleSuccess = (res) => {
        this.props.refresh();
        this.props.close();
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                {this.props.inactive?<h3>Biztos, hogy inaktiválni szeretnéd?</h3>:<h3>Biztos, hogy aktiválni szeretnéd?</h3>}
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Igen
                    </Button>
                </div>
            </form>

        )
    }
}

export default withSnackbar(ActivateObject);
